import { adDetector } from "../helpers/zones/ad_detector"
import {
  renderAdnimation,
  renderAdnimationVideo
} from "../helpers/zones/adnimation"
import { renderOutbrain } from "../helpers/zones/outbrain"
import { renderFiverr } from "../helpers/zones/fiverr"
import { renderCarbon, renderCarbonAuto } from "../helpers/zones/carbon"
import { hideHidden, showFallback, clear } from "../helpers/zones/zones"

const renderAds = () => {
  renderAdnimation()
  renderAdnimationVideo()
  renderOutbrain()
  renderFiverr()
  renderCarbon()
}

const renderNoAds = () => {
  renderCarbonAuto()
  hideHidden()
  showFallback()
}

document.addEventListener("turbo:load", () => {
  adDetector(renderAds, renderNoAds)
})

document.addEventListener("turbo:before-cache", clear)
